import { useNotifierContext } from '../contexts/NotifierContext';

/**
 * Custom hook for showing notifications using MUI Snackbar
 * 
 * @example
 * const { showSuccess, showError, showInfo, showWarning } = useNotifier();
 * 
 * showSuccess('Operation completed successfully!');
 * showError('Something went wrong');
 * showInfo('Here is some information');
 * showWarning('Please be careful', 8000); // Custom duration in ms
 */
export const useNotifier = () => {
    return useNotifierContext();
};

export default useNotifier;

